import http from "@/shared/services/http";

export const listDebtPostOffice = (params: any) =>  http.get(`v1/debt-post-offices`,  { params });
export const allCreditPostOffice = (params: any) =>  http.get(`v1/debt-post-offices/all`,  { params });
export const expensePostOffice = (data: any) => http.post(`v1/revenue-expenditures/post-office-pay`, data);